import { HttpErrorResponse } from '@angular/common/http';
import { PanelError } from '../traffic-history.models';

export function toPanelError(err: HttpErrorResponse): PanelError {
  const status = err?.status ?? null;
  const apiCode = err?.error?.error?.code ?? null;

  if (apiCode === 'TRAFFIC_NOT_MONITORED') {
    return {
      httpStatus: 403,
      code: apiCode,
      message: 'Esta institución no tiene monitoreo en tiempo real para las últimas 24 horas.',
      retryable: false,
    };
  }

  if (status === 403) {
    return {
      httpStatus: 403,
      code: apiCode,
      message: 'No tienes acceso a la información histórica de esta institución.',
      retryable: false,
    };
  }

  if (status === 502 || status === 503) {
    return {
      httpStatus: status,
      code: apiCode,
      message: 'El servicio de tráfico no está disponible en este momento.',
      retryable: true,
    };
  }

  return {
    httpStatus: status,
    code: apiCode,
    message: 'Ocurrió un error al cargar la información.',
    retryable: true,
  };
}
